export default __webpack_public_path__ + "static/media/icon_avatar.07d80dc6.png";